module.exports = __webpack_public_path__ + "img/bg 04 green.79507813.png";